/**
 * D3 -- name the thing the audit log is filtered to.
 *
 * The banner read "Filtered by entity:" and then a raw UUID. The kind
 * came off the rows; the name did not, because the audit table stores
 * no name -- so the one surface whose job is answering "what happened
 * to this thing" could not say which thing.
 *
 * It is recoverable without a new fetch: the product wrote these rows,
 * and what it wrote about the subject is in the payload. Only keys the
 * product uses as an identifier are read, in the order that a reader
 * would recognise, and only strings. Nothing is invented: with no
 * usable key the caller keeps the id, which is worse to read and
 * correct.
 */
const IDENTIFIER_KEYS = ["name", "code", "kind", "title", "label", "slug"] as const;

export interface LabelledRow {
  entity_id: string | null;
  payload?: Record<string, unknown> | null;
}

export function entityLabelFromRows(
  rows: LabelledRow[],
  entityId: string,
): string | null {
  for (const row of rows) {
    if (row.entity_id !== entityId) continue;
    const payload = row.payload;
    if (!payload || typeof payload !== "object") continue;
    for (const key of IDENTIFIER_KEYS) {
      const value = payload[key];
      if (typeof value === "string" && value.trim()) return value.trim();
    }
  }
  return null;
}
